import React, { useEffect } from 'react'
import { Row, Col, Button, message, Spin, ConfigProvider } from 'antd'
import Cookies from 'js-cookie'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setUserInfo } from '@/redux/actions/commonActions'
import { getTokenByCode } from '@/services/login'
import { redirectURL } from '@/utils/authHelp'
import { formatMessage, defaultRoleList } from '@/utils/common'
// import { getMenusFirstPath } from '@/annotations/nike-react'
// import routerConfig from '@/router/router'
import { messageModal } from '@/utils/modalUtils'
import { Base64 } from '@/utils/base64'
import _ from 'lodash'
import {
  showLang,
  defaultToken,
  defaultIdToken,
  defaultPermissions,
  defaultPermissionsComplete,
  defaultUserName,
  defaultAccount,
  defaultRoles
} from '@/utils/default'
import SelectLang from '@/components/selectLang'
import './Login.less'
const Login = () => {
  const dispatch = useDispatch()
  const spinLoading = useSelector(state => state.loadingStore.loading)
  const history = useHistory()
  const handleAuthenticate = () => {
    window.location.href = `${process.env.REACT_APP_OKTA_URL}${redirectURL}`
  }
  useEffect(() => {
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search)
      const error_des = searchParams.get('error_description')
      const code = searchParams.get('code')
      if (error_des) {
        messageModal('error', { content: formatMessage('languageObj.loginLocale.oktaError') })
        return
      }
      if (code) {
        loginFun(code)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const loginFun = code => {
    const params = {
      code,
      redirectUrl: redirectURL
    }
    getTokenByCode(params).then(res => {
      if (res && res.resultData) {
        const info = res.resultData
        Cookies.set(defaultToken, info.token)
        localStorage.setItem(defaultIdToken, info.idToken || '')
        localStorage.setItem(defaultUserName, info.nickname)
        localStorage.setItem(defaultAccount, info.nickname)
        // 转换成小写
        info.roles = info.roles.map(item => item.toLowerCase())
        let adminDefault = [
          {
            permissionName: 'Role management',
            mappingName: 'menu_role_management'
          },
          {
            permissionName: 'User management',
            mappingName: 'menu_user_management'
          }
        ]
        // 默认三个admin包含role,user
        if (_.intersection(defaultRoleList, info.roles).length > 0) {
          info.permissions = info.permissions.concat(adminDefault)
        }
        let localPermissions = info.permissions.map(item => {
          return item.mappingName
        })
        // 完整的permission
        const permissionsCompleteInfoString = Base64.encode(JSON.stringify(info.permissions))
        const permissionsString = Base64.encode(JSON.stringify(localPermissions))
        const rolesString = Base64.encode(JSON.stringify(info.roles))
        localStorage.setItem(defaultRoles, rolesString)
        localStorage.setItem(defaultPermissions, permissionsString)
        localStorage.setItem(defaultPermissionsComplete, permissionsCompleteInfoString)
        let infoCommon = {
          userName: info.nickname,
          account: info.nickname,
          permissionsCompleteInfo: JSON.stringify(info.permissions),
          permissions: JSON.stringify(localPermissions),
          roles: JSON.stringify(info.roles)
        }
        dispatch(setUserInfo(infoCommon))
        let path = ''
        let url = ''
        // 有权限的第一个页面
        // url = getMenusFirstPath(routerConfig)
        if (url) {
          path = url
        } else {
          path = '/'
        }
        history.push(path)
      } else {
        message.error('Login failed')
      }
    })
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          controlHeight: 40
        }
      }}
    >
      <Spin spinning={spinLoading} size="large" style={{ top: '50vh', transform: 'translateY(-50%)', zIndex: 10000 }}>
        <div className="login-page">
          {showLang ? (
            <div className="langWrapper">
              <SelectLang />
            </div>
          ) : null}
          <Row className="color-fader" type="flex" align="middle">
            <Col className="nike_zoom" style={{ width: 400, margin: '0 auto' }}>
              <div className="login-form">
                <div className="logo-wrapper">
                  <div className="login-form-logo">
                    <span className="nsg-glyph--swoosh" />
                  </div>
                </div>
                <div className="login-form-title">
                  <span>{formatMessage('languageObj.loginLocale.loginTitle')}</span>
                </div>
                <div className="login-form-body-item">
                  <Button type="primary" style={{ width: '100%' }} onClick={handleAuthenticate}>
                    {formatMessage('languageObj.loginLocale.loginBtn')}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Spin>
    </ConfigProvider>
  )
}

export default Login
